export default "__VITE_ASSET__PaUozAiR__"